<template>
  <div class="d-select text-dark"
       v-on-clickaway="onClickAway"
       ref="d_select"
       :class="{'openFromBottom': openFromBottom}">
    <div class="width-100 no-print">
      <div class="d-select__input-look"
           ref="toggle"
           @click="open"
           :class="{'active': showDropdown}">
        <div v-for="selectedItem in selectedItems"
             :key="selectedItem.id"
             class="d-select__selected__item"
             :class="[
               {'readyToDelete': isReadyToDelete(selectedItem)},
               {'d-select__selected__item--is-in-event': isInEvent},
               {'d-select__selected__item--cant-be-removed': isInItemsThatCantBeDeleted(selectedItem)}
               ]">
          <template v-if="isInEvent">
            <div class="d-select__selected__item__spinner__container" v-if="isLoadingAvailability">
              <div class="d-select__selected__item__spinner"></div>
            </div>
            <template v-else>
              <div v-if="isShowCollisions && selectedItem.v_occupation && selectedItem.v_occupation.length > 0"
                   class="d-select__selected__item__warning icon__bg-circle icon__bg-circle--small"
                   :content="getCollisionText(selectedItem)"
                   @click.stop="showCalendar(selectedItem)"
                   v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 1231231231233,
                    boundary: 'window'
                  }">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="tw-icon tw-icon--warning">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/>
                </svg>
              </div>
              <div v-else
                   class="icon__bg-circle icon__bg-circle--small"
                   :content="i18n['see_calendar']"
                   v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 1231231231233,
                    boundary: 'window'
                  }"
                   @click.stop="showCalendar(selectedItem)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="tw-icon tw-icon--calendar">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"/>
                </svg>
              </div>
            </template>
          </template>
          <div class="d-select__selected__item__name" @click.stop="showCalendar(selectedItem)">
            {{ selectedItem.name }}
          </div>
          <div v-if="!isInItemsThatCantBeDeleted(selectedItem)"
               @click.stop="removeUser(selectedItem)"
               class="d-select__selected__item__remove icon__bg-circle icon__bg-circle--small icon__bg-circle--danger">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon--close" width="24" height="24">
              <path class="secondary" fill-rule="evenodd"
                    d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"/>
            </svg>
          </div>
        </div>
        <div class="d-select__delete-all"
             v-if="selectedItems.length > 0 && isDeleteAllAnOption && itemsThatCantBeDeleted.length === 0"
             @click.stop="removeAllUsers">
          <div class="icon__bg-circle"
               :content="i18n['delete_all']"
               v-tippy="{
                 arrow: true,
                    placement : 'top',
                    zIndex: 1231231231233,
                    animation: 'hift-away'
                  }">
            <div class="d-select__delete-all__inner">
              <span class="icon-cross2"></span>
            </div>
          </div>
        </div>
        <Loader v-if="isLoadingAvailability" class="input__spinner" :isExtraSmall="true" bg-color="#fff"
                style="margin: 6px 5px 0 5px;" color="blue"
                size="small"></Loader>
        <Loader v-if="isLoading" class="input__spinner" :isExtraSmall="true" bg-color="#fff"
                style="margin: 6px 5px 0 5px;" color="blue"
                size="small"></Loader>
        <template v-else>
          <input type="search"
                 ref="inputfield"
                 v-model="searchText"
                 :placeholder="placeholderText"
                 class="d-select__header__search"
                 :class="[{'show': showDropdown}, {'input-active': searchText.length > 0 || selectedItems.length < 1}]"
                 @focus="open"
                 @paste="handlePaste"
                 @keypress="selectWithKeyboard('', $event)"
                 @keydown.enter.prevent="selectWithKeyboard('enter')"
                 @keydown.down.prevent="selectWithKeyboard('down')"
                 @keydown.up.prevent="selectWithKeyboard('up')"
                 @keydown.tab="selectWithKeyboard('tab')"
                 @keydown.delete="deleteUserWithKeyboard"/>
        </template>
      </div>
      <div class="d-select__items"
           ref="d_select__items"
           v-if="showDropdown"
           v-append-to-body>
        <ul class="d-select__items__container text-dark"
            ref="dropdown"
            @scroll="handleScroll"
            :content="metaKeyTooltip"
            v-tippy="{
                    arrow: true,
                    placement : 'left-start',
                    zIndex: 12312312312312
                  }">
          <template v-for="(item, index) in searchedUsers">
            <li
              v-if="index < maxLimit"
              :key="item.id"
              :class="[
              {'isReadyForSelection': isSelectedWithKeyboard(item)},
              {'item_is_selected': isSelected(item)}]"
              @mouseenter="setIsReadyForSelection(item, index)"
              @mousemove="isMouseMoved = true"
              @click.stop="toggleUser(item)">
              <div class="item-template"
                   :class="[
                     {'item-template--occupied': isShowCollisions && item.v_occupation && item.v_occupation.length > 0},
                     {'item-template--presence': isShowCollisions && item.v_presence && item.v_presence.length > 0 && item.v_occupation && item.v_occupation.length < 1}
                     ]"
              >
                <div class="item-template__left">
                  <span v-if="item.icon" :class="item.icon" class="marg-10-right"></span>
                  <img v-if="item.default_thumb_url" :src="item.default_thumb_url" alt="">
                  <div>{{ item.name }}</div>
                </div>
                <div class="item-template__calendar-year" v-if="showCalendarYear">{{ item.year }}</div>
                <ul v-if="isShowCollisions && item.v_occupation && item.v_occupation.length > 0"
                    class="item-template__occupations">
                  <span class="icon-warning"></span>
                  <li v-for="event in item.v_occupation" :key="event.event_id">{{ event.title }}</li>
                </ul>
              </div>
            </li>
          </template>
          <li class="infinite-scroll__bottom" ref="infinite_scroll" v-if="searchedUsers.length > maxLimit">
            <Loader :is-extra-small="true" bg-color="#fff" style="margin: 12px"></Loader>
          </li>
        </ul>
        <template v-if="showCreateButton && searchedUsers.length < 1">
          <div class="no-match" v-if="searchedUsers.length < 1 || (searchText.length > 0 && searchedUsers.length < 1)">
            <h4 class="create-new-item create-new-item--explained" v-if="searchText.length < 1">
              {{ $t('vue2.dselect.type_to_create') }}
            </h4>
            <h4 class="create-new-item" @click="createNew" v-else>
              + {{ $t('vue2.common.create') }} {{ searchText }}
            </h4>
          </div>
        </template>
        <div class="no-match" @click.stop v-if="!showCreateButton && searchedUsers.length < 1">
          <slot name="noMatch">
            <h4>{{ $t('vue2.dselect.no_matching_results') }}</h4>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import spinner from '../common/Spinner'
import {mixin as clickaway} from 'vue-clickaway'
import appendToBody from '../../directives/appendToBody'
import moment from 'moment'
import Loader from '../common/Loader'
import {createPopper} from '@popperjs/core'

const I18N = {
  da: {
    delete_all: 'Slet alle valgte',
    hold_down: 'Hold',
    to_select_multiple: 'nede for at vælge flere',
    see_calendar: 'Se kalender'
  },
  en: {
    delete_all: 'Remove all',
    hold_down: 'Hold down',
    to_select_multiple: 'to select multiple',
    see_calendar: 'See calender'
  },
  nb: {
    delete_all: 'Slett alle valgte',
    hold_down: 'Hold nede',
    to_select_multiple: 'for å velge flere',
    see_calendar: 'Se kalender'
  }
}

export default {
  mixins: [clickaway],
  directives: {appendToBody},
  components: {Loader, spinner},
  props: {
    items: {
      default: () => [],
      type: Array
    },
    itemsSelected: {
      default: () => [],
      type: Array
    },
    itemsUnselectable: {
      default: () => [],
      type: Array
    },
    itemsThatCantBeDeleted: {
      default: () => [],
      type: Array
    },
    isLoading: {
      default: false,
      type: Boolean
    },
    isLoadingAvailability: {
      default: false,
      type: Boolean
    },
    allDataLoaded: {
      default: false,
      type: Boolean
    },
    show: {
      default: false,
      type: Boolean
    },
    multiple: {
      default: true,
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    eventId: {
      type: Number,
      required: false
    },
    event: {
      type: Object,
      default: () => null,
      required: false
    },
    appendToBody: {
      default: false
    },
    calculatePosition: {
      type: Function,
      default (dropdownList, component, {top, left}) {
        dropdownList.style.top = top
        dropdownList.style.left = left
      }
    },
    showCreateButton: {
      default: false,
      type: Boolean
    },
    newUserCalendarId: {
      default: null
    },
    disableAddMore: {
      type: Boolean,
      default: false
    },
    isDeleteAllAnOption: {
      type: Boolean,
      default: true
    },
    isShowCollisions: {
      type: Boolean,
      default: false
    },
    showCalendarYear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    locale () {
      return window.USER && window.USER.language ? window.USER.language : 'en'
    },
    i18n () {
      return I18N[this.locale]
    },
    isInEvent () {
      return this.event !== null
    },
    withoutSelectedItems () {
      const itemsFiltered = this.items.filter(item => !this.itemsUnselectable.includes(item.id))
      return itemsFiltered.filter(el => {
        return this.selectedItems.filter(secEl => {
          return secEl.id === el.id
        }).length === 0
      })
    },
    searchedUsers () {
      if (this.disableAddMore) {
        return []
      }
      return this.withoutSelectedItems.filter(user => {
        return user.name !== '' ? user.name.match(new RegExp(this.searchText, 'i')) : ''
      })
    },
    placeholderText () {
      let placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder')
      return this.selectedItems.length > 0 ? '' : placeholder
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    metaKeyTooltip () {
      return '<p class="tooltip-shortcut">' + this.i18n['hold_down'] + '<span>' + this.metaKey + '</span>' + this.i18n['to_select_multiple'] + '</p>'
    }
  },
  data () {
    return {
      showDropdown: false,
      searchText: '',
      selectedItems: [],
      keyboardSelected: null,
      keyboardSelectedIndex: 0,
      readyToDelete: null,
      openFromBottom: false,
      readyToReceive: false,
      maxLimit: 400,
      addLimit: 400,
      isKeepOpen: false,
      _keyListenerOne: null,
      _keyListenerTwo: null,
      isMouseMoved: false
    }
  },
  watch: {
    // Close from from component
    show () {
      if (!this.show) {
        this.close()
      }
    },
    searchedUsers (newVal) {
      if (this._preserveKeyboardIndex) {
        this._preserveKeyboardIndex = false
        if (this.keyboardSelectedIndex >= newVal.length) {
          this.keyboardSelectedIndex = Math.max(0, newVal.length - 1)
        }
        this.keyboardSelected = newVal[this.keyboardSelectedIndex] || null
      } else {
        this.keyboardSelectedIndex = 0
        this.keyboardSelected = newVal[0]
      }
    },
    searchText () {
      this.$emit('searchText', this.searchText)
    },
    selectedItems () {
      this.$nextTick(this.updatePopper)
    },
    allDataLoaded () {
      this.sortselectedItems()
    },
    isLoadingSchoolCalenders (val) {
      if (!val && this.newUserCalendarId) {
        console.log('this.newUserCalendarId', this.newUserCalendarId)
      }
    },
    itemsSelected (val) {
      const preSelectedIds = val.map(calendar => calendar.id)
      const selectedItems = this.selectedItems.map(cal => cal.id)
      if (preSelectedIds.sort().join(',') === selectedItems.sort().join(',')) {
        // same calendars
      } else {
        // not matching
        this.selectedItems = this.itemsSelected
      }
    }
  },
  filters: {
    localeTime (eventTime) {
      return moment(eventTime).format('LT')
    }
  },
  methods: {
    onClickAway () {
      this.close()
      this.$emit('close')
    },
    isInItemsThatCantBeDeleted (selectedItem) {
      return this.itemsThatCantBeDeleted.indexOf(selectedItem.id) > -1
    },
    isReadyToDelete (user) {
      if (!this.readyToDelete) {
        return
      }
      return this.readyToDelete.id === user.id
    },
    scrollTokeyboardSelected () {
      setTimeout(() => {
        let user = document.querySelector('.isReadyForSelection')
        let selectedOffsetTop = user.offsetTop
        let selectedHeight = user.getBoundingClientRect().height
        let totalHeight = selectedOffsetTop + selectedHeight

        let top = this.$refs.dropdown.scrollTop
        let height = this.$refs.dropdown.getBoundingClientRect().height
        let bottom = top + height

        if (totalHeight > bottom) {
          this.isMouseMoved = false
          this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop + selectedHeight
        }

        if (selectedOffsetTop < top) {
          this.isMouseMoved = false
          this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop - selectedHeight
        }
      }, 0)
    },
    setIsReadyForSelection (user, idx) {
      if (!this.isMouseMoved) {
        return
      }
      this.keyboardSelected = null
      this.keyboardSelected = user
      this.keyboardSelectedIndex = idx
    },
    selectWithKeyboard (stroke, e) {
      // Open Dropdown if closed and typing
      if (!this.showDropdown) {
        this.open()
      }
      if (stroke === 'tab') {
        if (this.searchText.length > 0 && this.searchedUsers.length < 1) {
          this.createNew()
          this.close()
          return
        }
        this.close()
      }
      if (stroke === 'down') {
        if ((this.keyboardSelectedIndex + 1) >= this.searchedUsers.length) {
          return
        }
        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1
        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex]
        this.scrollTokeyboardSelected()
      }
      if (stroke === 'up') {
        if ((this.keyboardSelectedIndex - 1) < 0) {
          return
        }
        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1
        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex]
        this.scrollTokeyboardSelected()
      }
      if (stroke === 'enter') {
        if (this.keyboardSelected === null) {
          return
        }
        if (this.searchedUsers.length < 1) {
          this.$emit('enter')
          return
        }
        this._preserveKeyboardIndex = true
        this.toggleUser(this.keyboardSelected)
      }
    },
    isSelectedWithKeyboard (user) {
      return this.keyboardSelected && this.keyboardSelected.id === user.id
    },
    handlePaste (event) {
      // Gate: kun hvis en parent eksplicit lytter på multiPaste, ellers
      // skal komponenten opføre sig præcis som før alle andre steder.
      if (!this.$listeners || !this.$listeners.multiPaste) {
        return
      }
      const clipboard = event.clipboardData || window.clipboardData
      if (!clipboard) {
        return
      }
      const text = clipboard.getData('text')
      if (!text || text.length < 1) {
        return
      }
      const looksMulti = text.indexOf(',') > -1 || text.indexOf(';') > -1 || text.indexOf('\n') > -1 || text.indexOf('\t') > -1
      if (!looksMulti) {
        return
      }
      event.preventDefault()
      this.$emit('multiPaste', text)
      this.searchText = ''
    },
    deleteUserWithKeyboard () {
      if (this.searchText.length > 0 || this.selectedItems.length < 1) {
        return
      }
      if (this.itemsThatCantBeDeleted.length > 0) {
        return
      }
      if (this.readyToDelete === null) {
        this.readyToDelete = this.selectedItems[this.selectedItems.length - 1]
      } else {
        this.removeUser(this.selectedItems[this.selectedItems.length - 1])
        this.readyToDelete = null
      }
    },
    close () {
      if (!this.showDropdown) {
        return
      }
      this.showDropdown = false
      this.destroyPopper()
      this.keyboardSelected = null
      this.keyboardSelectedIndex = 0
      this.readyToDelete = null
      this.searchText = ''
      this.$emit('show', false)
      this.openFromBottom = false
      this.maxLimit = 400
      this.removeKeyboardShortCuts()
      this.isKeepOpen = false
    },
    open () {
      if (this.showDropdown) {
        return
      }
      this.showDropdown = true
      this.$emit('show', true)
      this.setFocus()
      this.keyboardSelectedIndex = 0
      this.keyboardShortcut()
      this.$nextTick(_ => {
        this.createPopper()
      })
    },
    toggleUser (item) {
      if (item.tag) {
        this.selectAllWithTag(item.name)
        return
      }
      if (this.isSelected(item)) {
        this.removeUser(item)
      } else {
        if (item.isOnLesson) {
          this.$emit('addIsOnLesson', item)
          this.close()
          return
        }
        if (this.multiple) {
          this.selectedItems.push(item)
          this.$emit('add', item)
          this.readyToDelete = null
          this.searchText = ''
          this.setFocus()
        } else {
          this.selectedItems = []
          this.selectedItems.push(item)
          this.$emit('add', item)
        }
        this.$emit('update', this.selectedItems)
      }
      if (!this.isKeepOpen) {
        this.close()
      }
    },
    createPopper () {
      let source = this.$refs.d_select__items
      let el = this.$refs.d_select
      if (!source || !el) {
        return
      }
      this.destroyPopper()
      document.getElementById('djs-content-container').appendChild(source)
      const elRect = el.getBoundingClientRect()
      source.style.width = elRect.width + 'px'
      // Siden vælges én gang ved åbning; popper's flip ville ellers kunne skifte
      // mellem top og bund ved hver opdatering (scroll, resize, valgte brugere).
      const spaceBelow = window.innerHeight - elRect.bottom
      const spaceAbove = elRect.top
      const fitsBelow = source.offsetHeight <= spaceBelow || spaceBelow >= spaceAbove
      this.popperInstance = createPopper(el, source, {
        placement: fitsBelow ? 'bottom-start' : 'top-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 0]
            }
          },
          {
            name: 'flip',
            enabled: false
          }
        ]
      })
    },
    updatePopper () {
      if (this.popperInstance) {
        this.popperInstance.update()
      }
    },
    destroyPopper () {
      if (this.popperInstance) {
        this.popperInstance.destroy()
        this.popperInstance = null
      }
    },
    selectAllWithTag (tag) {
      let usersWithTag = this.items.filter(item => {
        return item.user_tags && item.user_tags.indexOf(tag) > -1
      })
      usersWithTag.forEach(user => {
        let idx = this.items.findIndex(x => x.id === user.id)
        if (!this.isSelected(this.items[idx])) {
          this.selectedItems.push(this.items[idx])
        }
      })
      this.close()
      this.$emit('update', this.selectedItems)
      this.$emit('add', this.selectedItems)
    },
    removeUser (item) {
      this.selectedItems.splice(this.selectedItems.indexOf(item), 1)
      this.$emit('remove', item)
      this.$emit('update', this.selectedItems)
      this.close()
    },
    removeAllUsers () {
      this.selectedItems.forEach(item => {
        this.$emit('remove', item)
      })
      this.selectedItems.splice(0, this.selectedItems.length)
      this.$emit('update', this.selectedItems)
      this.close()
    },
    isSelected (user) {
      return this.selectedItems.indexOf(user) > -1
    },
    setFocus () {
      this.$refs.inputfield.focus()
    },
    sortselectedItems () {
      this.selectedItems = this.selectedItems.sort((a, b) => {
        var x = a.name.toLowerCase()
        var y = b.name.toLowerCase()
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    createNew () {
      this.$emit('createNew', this.searchText)
      this.readyToReceive = true
      this.close()
    },
    loadMoreCalendars () {
      if (this.searchedUsers.length < this.maxLimit) {
        this.maxLimit = this.maxLimit + this.addLimit
      }
    },
    handleScroll (evt) {
      let element = evt.target
      // scrolledToBottom
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        this.loadMoreCalendars()
      }
    },
    getCollisionText (selectedItem) {
      return selectedItem.v_occupation.map(event => event.title)
    },
    showCalendar (item) {
      this.$emit('showCalendar', item)
    },
    keyboardShortcut () {
      if (this._keyListenerOne) {
        return
      }
      const self = this
      this._keyListenerOne = function (e) {
        if (e.key === 'Meta' || e.key === 'Control') {
          e.preventDefault()
          if (!self.isKeepOpen) {
            self.isKeepOpen = true
          }
        }
      }
      this._keyListenerTwo = function (e) {
        if (e.key === 'Meta' || e.key === 'Control') {
          e.preventDefault()
          self.isKeepOpen = false
        }
      }
      document.addEventListener('keydown', this._keyListenerOne)
      document.addEventListener('keyup', this._keyListenerTwo)
    },
    removeKeyboardShortCuts () {
      document.removeEventListener('keydown', this._keyListenerOne)
      document.removeEventListener('keyup', this._keyListenerTwo)
      this._keyListenerOne = null
      this._keyListenerTwo = null
    }
  },
  mounted () {
    if (this.show) {
      this.open()
    }
    this.selectedItems = this.itemsSelected
  },
  beforeDestroy () {
    this.removeKeyboardShortCuts()
    this.destroyPopper()
    // remove the dropdown from the DOM
    let source = this.$refs.d_select__items
    if (source) {
      source.remove()
    }
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.d-select {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 30px;
}

.d-select__header__search {
  width: 100%;
  transition: width 0.25s;
  border-radius: 4px;
}

.d-select__input-look {
  padding-right: 35px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  transition: width 0.25s;
  border-radius: 4px;
  background: white;
  cursor: text;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
  min-height: 34px;
}

.d-select__input-look.active {
  border: 1px solid var(--blue);
  border-radius: 4px 4px 0 0;
}

.d-select.openFromBottom .d-select__input-look.active {
  border-radius: 0 0 4px 4px;
}

.input__spinner {
  position: absolute;
  right: 0.5rem;
  top: 0;
}

.d-select__input-look input[type="search"] {
  border: none !important;
  width: 30px;
}

.d-select__input-look input[type="search"].input-active {
  width: 200px;
}

.d-select__selected__item {
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  width: max-content;
  color: #333;
  border: 1px solid #c8d6e2;
  background: #f6f9fc;
  border-radius: 4px;
  height: 26px;
  margin: 4px 1px 4px 3px;
  padding: 1px .25rem;
  float: left;
  line-height: 24px;
}

.d-select__selected__item.d-select__selected__item--is-in-event {
  padding: 0;
}

.d-select__selected__item__calendar {
  display: none;
}

.d-select__selected__item:hover .d-select__selected__item__calendar {
  display: flex;
}

.d-select__selected__item.readyToDelete {
  background-color: var(--danger);
}

.d-select__selected__item__remove {
  float: none;
  margin-right: 0;
  font-size: 20px;
  appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  font-weight: 700;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .2;
}

.d-select__selected__item__remove:hover {
  opacity: 1;
}

.d-select__items {
  position: absolute;
  z-index: 123123123123;
  background-color: #ffffff;
  padding: 0;
  width: 100%;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid var(--blue);
  border-width: 0 1px 1px 1px;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, .2), 0 0 0 1px rgba(0, 0, 0, .05);
}

.d-select.openFromBottom .d-select__items {
  top: auto;
  bottom: 100%;
  border-width: 1px 1px 0px 1px;
  border-radius: 4px 4px 0 0;
}

.d-select__items__container {
  max-height: 50vh;
  overflow-y: auto;
  margin: 0;
}

.d-select__items h4 {
  padding: 5px 15px;
}

.d-select__items li.isReadyForSelection {
  background-color: var(--blue);
  color: white;
}

.item_is_selected {
  background-color: #cccccc;
}

.item-template {
  display: flex;
  align-items: center;
  border-left: 2px solid transparent;
  padding: 5px 15px;
  cursor: pointer;
  justify-content: space-between;
}

.item-template.item-template--occupied {
  background-color: rgba(251, 127, 152, 0.5);
  border-left: 2px solid #fb7f98;
  color: black;
}

.item-template.item-template--presence {
  background-color: rgba(153, 197, 244, 0.5);
  border-left: 2px solid #99c5f4;
  color: black;
}


.item-template > div {
  display: flex;
  align-items: center;
}

.item-template > div > img {
  height: 18px;
  margin-right: 10px;
}

.item-template.isOccupied {
  background-color: rgba(251, 127, 152, 0.5);
  border-left: 2px solid #fb7f98;
  color: black;
}

.item-template.isOccupied.item-is-present {
  background-color: rgba(153, 197, 244, 0.5);
  border-left: 2px solid #99c5f4;
  color: black;
}

.item-template.isOccupied.item-is-already-attached {
  background-color: rgba(136, 209, 170, 0.5);
  border-left: 2px solid #4CAF50;
  color: black;
}

.no-match {
  background: #f4f4f4;
  border-radius: 0 0 4px 4px;
}

.warning-signs {
  display: flex;
  align-items: center;
}

warning-signs__sign {
  margin-right: 10px;
  display: flex;
}

.warning-sign > span {
  margin-right: 5px;
}

.item__icon-warning {
  display: block;
  padding: 2px 4px;
  font-size: 10px;
  background-color: rgba(251, 127, 152, 0.5);
  border-left: 2px solid #fb7f98;
  color: black;
}

.item_icon__hide {
  display: none !important;
}

.d-select__selected__item__secret-label {
  display: none !important;
  position: absolute;
  z-index: 100;
  align-items: center;
  bottom: calc(100%);
  left: calc(100% - 39px);
  font-size: 10px;
  padding: 0 6px 0 4px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, .3);
  background-color: #fdc4cf;
  border-left: 2px solid #fb7f98;
  color: black;
}

.item__icon-warning:hover + .d-select__selected__item__secret-label {
  display: flex !important;
  transform: translateY(2px);
  transition: all 1s;
}

.d-select__selected__item__secret-label__event {
  display: flex;
  margin-left: 2px;
}

.d-select__selected__item__secret-label__event:after {
  content: ',';
}

.d-select__selected__item__secret-label__event:last-child:after {
  content: '';
}

.create-new-item {
  cursor: pointer;
  margin: 0;
  background-color: var(--purple);
  color: #ffffff;
  font-size: 12px;
  transition: background-color 0.25s;
}

.item-template__occupations {
  display: flex;
  align-items: center;
  margin: 0;
}

.item-template__occupations > * {
  margin-right: 0.25rem;
}

.item__name__clickable {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.item__name__clickable:before {
  content: '';
  background: rgba(0, 0, 0, .1);
  border-radius: 4px;
  top: 2px;
  left: -2px;
  width: calc(100% + 6px);
  position: absolute;
  height: calc(100% - 4px);
  opacity: 0;
  transition: opacity .3s;
}

.item__name__clickable:hover:before {
  opacity: 1;
}

.d-select__delete-all {
  position: absolute;
  right: 0;
  top: 1px;
}

.d-select__delete-all__inner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--grey);
  font-size: 10px;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0);
}

.icon__bg-circle:hover .d-select__delete-all__inner {
  background: var(--danger);
}

.d-select > div:first-child:hover .d-select__delete-all__inner {
  transform: scale(1);
}

.tw-icon--warning {
  stroke: #e74c3c;
}

.tw-icon--calendar {
  width: 14px;
  stroke: #7f8183;
}

.d-select__selected__item--cant-be-removed > .d-select__selected__item__name {
  margin-right: 5px;
}

.d-select__selected__item__spinner__container {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-select__selected__item__spinner {
  height: 14px;
  width: 14px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.item-template__calendar-year {
  opacity: 0.4;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// DSelectCals.vue?9951779a